// DOM-Referenzen
const quiz_form = document.querySelector("#quizForm");
const answers = {};
let currentQuestionIndex = 0;
let currentEditKey = "";

// Buttons
const prev_btn = document.getElementById("prev-button");
const next_btn = document.getElementById("next-button");
const finish_btn = document.getElementById("finish-button");

// Elemente für das "Quiz Neustarten"-Pop-Up
const restartQuizButton = document.getElementById("restartQuizButton");
const cancelRestartButton = document.getElementById("cancelRestartButton");
const confirmRestartButton = document.getElementById("confirmRestartButton");

// Referenzen für das Bearbeitungs-Modal
const closeModal = document.getElementById("closeModal");
const confirmCloseModal = document.getElementById("closeConfirmSection");
const closeEditButtons = document.querySelectorAll("#cancelEditButton");
const editQuestionText = document.getElementById("editQuestionText");
const editOptionsContainer = document.getElementById("editOptionsContainer");
const saveEditButton = document.getElementById("saveEditButton");

// Referenzen für die neuen Bereiche
const resultStep1 = document.getElementById("resultStep1");
const resultStep2 = document.getElementById("resultStep2");
const nextButton = document.getElementById("nextButton");
const backToStep1 = document.getElementById("backToStep1");

// Referenzen für Kontaktformular
const consultationForm = document.getElementById("consultation-form");
const contactForm = document.getElementById("contactForm");
const backToStep2 = document.getElementById("backToStep2");
const consultationOption = document.getElementById("consultation");

// Referenz für die Weiterleitung in die jeweilige Collection
const browseBikesOption = document.getElementById("browseBikes");

// Dynamische Fragensteuerung
const questionFlow = [];
let previousBikeType = null;

//----------------Bikeberater Fragen und Funktionen-----------------------------\\

function showDrawerSection(sectionId) {
  document.querySelectorAll(".drawer-section").forEach((sec) => sec.classList.remove("active"));
  document.getElementById(sectionId)?.classList.add("active");

  const sectionsThatShouldLockScroll = [
    "quizSection",
    "resultSection",
    "editSection",
    "consultationSection",
    "restartConfirmSection",
    "closeConfirmSection"
  ];

  if (sectionsThatShouldLockScroll.includes(sectionId)) {
    disableBodyScroll();
  } else {
    enableBodyScroll();
  }

}

function disableBodyScroll() {
  document.body.classList.add("no-scroll");
}

function enableBodyScroll() {
  document.body.classList.remove("no-scroll");
}

function hideDrawerSections() {
  document.querySelectorAll(".drawer-section").forEach((sec) => sec.classList.remove("active"));
}

function updateFooterSection(sectionId) {
  document.querySelectorAll(".footer-group").forEach((group) => {
    group.classList.add("hidden-bb");
  });

  document.getElementById("nav-buttons")?.classList.add("hidden-bb");
  document.getElementById(sectionId)?.classList.remove("hidden-bb");
}

//PROGRESS-BAR
function animateProgressNumber(targetElement, start, end, duration) {
    let startTime = null;

    function step(currentTime) {
        if (!startTime) startTime = currentTime;
        let progress = Math.min((currentTime - startTime) / duration, 1);
        let value = Math.floor(start + progress * (end - start));

        targetElement.textContent = value + "%";

        if (progress < 1) {
            requestAnimationFrame(step);
        }
    }

    requestAnimationFrame(step);
}

function updateProgress() {
    const totalQuestions = questionFlow.length;
    
    // Nur die Fragen zählen, die wirklich beantwortet wurden UND noch im Flow sind
    let answeredQuestions = questionFlow.filter(q => answers[q]).length;

    // Prüfen, ob die aktuelle Frage eine Budgetfrage ist
    let isBudgetQuestion = questionFlow[currentQuestionIndex]?.startsWith("bike_budget_") || questionFlow[currentQuestionIndex]?.startsWith("ebike_budget_");

    // Prüfen, ob die aktuelle Frage die letzte Frage im Flow ist
    let isLastQuestion = currentQuestionIndex === totalQuestions - 1;

    // Falls Budgetfrage beantwortet wurde, Fortschritt auf 100% setzen
    if (isLastQuestion && isBudgetQuestion && answers[questionFlow[currentQuestionIndex]]) {
        answeredQuestions = totalQuestions;
    }

    // Fortschritt berechnen
    let progressPercentage = Math.round((answeredQuestions / totalQuestions) * 100);

    const progressBar = document.getElementById("progress-bar");
    const progressText = document.getElementById("progress-percentage");

    // Fortschrittsanzeige aktualisieren
    progressBar.style.width = progressPercentage + "%";

    // Zeige die Prozentanzeige nur, wenn Fortschritt größer als 0% ist
    if (progressPercentage > 0) {
        progressText.style.opacity = "1";  // Einblenden
    } else {
        progressText.style.opacity = "0";  // Versteckt bleiben
    }

    // Animierte Prozentanzeige aktualisieren
    let previousValue = parseInt(progressText.textContent.replace("%", "")) || 0;
    animateProgressNumber(progressText, previousValue, progressPercentage, 800);

    // Fortschrittstext aktualisieren
    document.getElementById("current-step").textContent = answeredQuestions;
    document.getElementById("total-steps").textContent = totalQuestions;
}

//Dynamische Steuerung der Fragenabfolge
function updateQuestionFlow() {
    if (!window.quizStarted) {
      window.dataLayer.push({
        event: 'bikeberater',
        bikeberaterAction: 'start'
      });
      window.quizStarted = true;
    }
    questionFlow.length = 0;
    questionFlow.push("target_audience");

    if (answers.bike_type !== previousBikeType) {
        previousBikeType = answers.bike_type;
    }

    if (answers.target_audience === "Kinder") {
        questionFlow.push("bike_type");

        if (answers.bike_type === "Muskelkraft") {
            questionFlow.push("kids_age_bike");
        } else if (answers.bike_type === "E-Bike") {
            questionFlow.push("kids_age_ebike");
        }

    } else {

        questionFlow.push("bike_type");

        if (answers.bike_type === "Muskelkraft") {
            questionFlow.push("driving_style_muskelkraft");
        } else if (answers.bike_type === "E-Bike") {
            questionFlow.push("driving_style_ebike");
        }

        // Detailfragen je nach Fahrstil
        if (answers.bike_type === "Muskelkraft" && answers.driving_style_muskelkraft) {
            const style = answers.driving_style_muskelkraft;
            if (style === "Hauptsächlich Asphalt & Radwege") {
              questionFlow.push("driving_style_option1");
            } else if (style === "Feldwege, Schotter, gemischtes Gelände") {
              questionFlow.push("driving_style_option2");
            } else if (style === "Ruppige Trails & bergiges Gelände") {
              questionFlow.push("driving_style_option3");
            }
        }

        if (answers.bike_type === "E-Bike" && answers.driving_style_ebike) {
            const style = answers.driving_style_ebike;
            if (style === "Hauptsächlich Asphalt & Radwege") {
              questionFlow.push("driving_style_option1");
            }
            else if (style === "Feldwege, Schotter, gemischtes Gelände") { 
              questionFlow.push("driving_style_option2");
            }
            else if (style === "Ruppige Trails & bergiges Gelände") { 
              questionFlow.push("driving_style_option3");
            }
        }
    }

    // ----------- KATEGORIE-MAPPING ----------- //
    let category = "fully"; // fallback
    const style1 = answers.driving_style_option1;
    const style2 = answers.driving_style_option2;
    const style3 = answers.driving_style_option3;

    const styleChoice = style1 || style2 || style3;

    if (answers.bike_type === "Muskelkraft" && answers.driving_style_muskelkraft && styleChoice) {
        const categoryMap = {
            "Hauptsächlich Asphalt & Radwege": {
                "Sportlich & schnell": "rennrad",
                "Komfortabel & alltagstauglich": "city_urban",
                "Ich will auch längere Touren fahren": "trekking"
            },
            "Feldwege, Schotter, gemischtes Gelände": {
                "Komfortabel & stabil": "trekking",
                "Schnell & effizient": "gravel",
                "Ich will auch mal ins Gelände, aber nicht zu extrem": "hardtail"
            },
            "Ruppige Trails & bergiges Gelände": {
                "Leichte Trails, Waldwege, kleinere Wurzeln & Steine": "hardtail",
                "Ich will richtig ins Gelände, Wurzeln, Sprünge & steile Abfahrten": "fully"
            }
        };

        category = categoryMap[answers.driving_style_muskelkraft]?.[styleChoice] || "fully";
    }

    if (answers.bike_type === "E-Bike" && answers.driving_style_ebike && styleChoice) {
        const categoryMap = {
            "Hauptsächlich Asphalt & Radwege": {
                "Sportlich & schnell": "rennrad",
                "Komfortabel & alltagstauglich": "city_urban",
                "Ich will auch längere Touren fahren": "trekking"
            },
            "Feldwege, Schotter, gemischtes Gelände": {
                "Komfortabel & stabil": "trekking",
                "Schnell & effizient": "gravel",
                "Ich will auch mal ins Gelände, aber nicht zu extrem": "hardtail"
            },
            "Ruppige Trails & bergiges Gelände": {
                "Leichte Trails, Waldwege, kleinere Wurzeln & Steine": "hardtail",
                "Ich will richtig ins Gelände, Wurzeln, Sprünge & steile Abfahrten": "fully",
                "Ich will ein leichtes, sportliches E-Bike für Trails & Touren": "light_mtb"
            }
        };

        category = categoryMap[answers.driving_style_ebike]?.[styleChoice] || "fully";
    }

    selectedBikeCategory = category;

    // ----------- BUDGET-FRAGE NUR FÜR ERWACHSENE ----------- //
    if (answers.target_audience !== "Kinder") {
        if (category) {
            const budgetQuestion = answers.bike_type === "Muskelkraft" ? `bike_budget_${category}` : `ebike_budget_${category}`;
            if (!questionFlow.includes(budgetQuestion)) {
                questionFlow.push(budgetQuestion);
            }
        }
    }

    // Index und Antworten bereinigen
    currentQuestionIndex = Math.min(currentQuestionIndex, questionFlow.length - 1);
    Object.keys(answers).forEach((key) => {
        if (!questionFlow.includes(key)) delete answers[key];
    });

    updateButtonStates();
}


//Event-Listener für den "Zurück"-Button
prev_btn.addEventListener("click", function () {
    window.dataLayer.push({
      event: 'bikeberater',
      bikeberaterAction: 'nav_back',
      bikeberaterFromStep: currentQuestionIndex + 1,
      bikeberaterToStep: currentQuestionIndex,
      bikeberaterAnsweredQuestion: questionFlow[currentQuestionIndex],
      bikeberaterTargetAudience: answers.target_audience || null,
      bikeberaterBikeType: answers.bike_type || null,
      bikeberaterDrivingStyle: answers.driving_style_muskelkraft || answers.driving_style_ebike || null,
      bikeberaterStyleChoice: answers.driving_style_option1 || answers.driving_style_option2 || answers.driving_style_option3 || null,
      bikeberaterBudget: (
        answers[`bike_budget_${selectedBikeCategory}`] ||
        answers[`ebike_budget_${selectedBikeCategory}`] ||
        null
      ),
      bikeberaterCategory: selectedBikeCategory || null,  
    });

    if (currentQuestionIndex > 0) {
        const currentQuestionKey = questionFlow[currentQuestionIndex];

        // Falls vorher keine Antwort existierte, Fortschritt anpassen
        if (answers[currentQuestionKey]) {
            delete answers[currentQuestionKey]; // Antwort entfernen
        }

        currentQuestionIndex--;

        displayQuestion();
        updateButtonStates();
        toggleNextButton();
        updateProgress(); // Fortschritt neu berechnen
    }
});

//Event-Listener für den "Nächste"-Button
next_btn.addEventListener("click", function () {
  window.dataLayer.push({
    event: 'bikeberater',
    bikeberaterAction: 'nav_next',
    bikeberaterFromStep: currentQuestionIndex + 1,
    bikeberaterToStep: currentQuestionIndex + 2,
    bikeberaterAnsweredQuestion: questionFlow[currentQuestionIndex],
    bikeberaterAnswer: answers[questionFlow[currentQuestionIndex]],
    bikeberaterTargetAudience: answers.target_audience || null,
    bikeberaterBikeType: answers.bike_type || null,
    bikeberaterDrivingStyle: answers.driving_style_muskelkraft || answers.driving_style_ebike || null,
    bikeberaterStyleChoice: answers.driving_style_option1 || answers.driving_style_option2 || answers.driving_style_option3 || null,
    bikeberaterBudget: (
      answers[`bike_budget_${selectedBikeCategory}`] ||
      answers[`ebike_budget_${selectedBikeCategory}`] ||
      null
    ),
    bikeberaterCategory: selectedBikeCategory || null,
  });

  if (currentQuestionIndex < questionFlow.length - 1) {
    currentQuestionIndex++;
    displayQuestion();
    updateButtonStates();
  }
});

// Helferfunktion: Setzt den Fortschritt sofort auf 100 %, wenn Budgetfrage als letzte beantwortet wird
function forceProgressTo100IfFinal() {
    setTimeout(() => {
        const isLastQuestion = currentQuestionIndex === questionFlow.length - 1;
        const isBudgetQuestion =
            questionFlow[currentQuestionIndex]?.startsWith("bike_budget_") ||
            questionFlow[currentQuestionIndex]?.startsWith("ebike_budget_");

        if (isLastQuestion && isBudgetQuestion && answers[questionFlow[currentQuestionIndex]]) {
            const progressBar = document.getElementById("progress-bar");
            const progressText = document.getElementById("progress-percentage");

            progressBar.style.width = "100%";
            animateProgressNumber(progressText, parseInt(progressText.textContent) || 0, 100, 800);

            document.getElementById("current-step").textContent = questionFlow.length;
            document.getElementById("total-steps").textContent = questionFlow.length;

            progressText.style.opacity = "1";
        } else {
            updateProgress();
        }
    }, 0);
}

//Funktion zum Rendern der aktuellen Frage
function displayQuestion() {

    const current_question_key = questionFlow[currentQuestionIndex];
    const current_question = questions.find(q => q.name === current_question_key);
    if (!current_question) return;

    let filteredOptions = [...current_question.options];

    // Falls die aktuelle Frage "driving_style_option3" ist und Muskelkraft gewählt wurde
    if (current_question.name === "driving_style_option3" && answers.bike_type === "Muskelkraft") {
        filteredOptions = filteredOptions.filter(option => option.value !== "Ich will ein leichtes, sportliches E-Bike für Trails & Touren");
    }

    // Falls eine der Altersfragen aktiv ist, aber "Kinder" NICHT gewählt wurde → Frage überspringen
    if ((current_question.name === "kids_age_bike" || current_question.name === "kids_age_ebike") && answers.target_audience !== "Kinder") {
        return;
    }

    const selected_answer = answers[current_question.name] || "";

    quiz_form.innerHTML = `
      <h2 class="advisor_heading">${current_question.text}</h2>
      ${current_question.description ? `<p class="advisor_description">${current_question.description}</p>` : ""}
      <div class="label-container">
        ${filteredOptions
            .map(
                (option) => `
                <input
                    type="radio"
                    id="${option.value}"
                    name="${current_question.name}"
                    value="${option.value}"
                    ${option.value === selected_answer ? "checked" : ""}
                /> 
                <label for="${option.value}" class="quiz-option" data-value="${option.value}">
                    <div class="img-wrap">
                        <img src="${option.img}" alt="${option.label}" />
                    </div>
                    <div class="option-inner heading-text-inner">
                        <h3 class="option-heading">${option.label}</h3>
                        ${option.description ? `<p class="advisor_description">${option.description}</p>` : ""}
                    </div>
                </label>
            `
            )
            .join("")}
      </div>
    `;

    // Event-Listener für Radio-Change
    document.querySelectorAll(`input[name="${current_question.name}"]`).forEach(input => {
        input.addEventListener("change", function (event) {
            const newValue = event.target.value;

            // Antwort speichern
            answers[current_question.name] = newValue;

            // Antworten einfärben
            highlightSelectedAnswer(current_question.name);

            // Fragenflow updaten
            updateQuestionFlow();

            // Fortschritt aktualisieren
            forceProgressTo100IfFinal();

            // Falls nicht letzte Frage, zur nächsten gehen
            if (currentQuestionIndex < questionFlow.length - 1) {
                currentQuestionIndex++;
                displayQuestion();
            }

            toggleNextButton();
            updateButtonStates();
        });
    });

    // Fix für Klick auf Bild & Text
    document.querySelectorAll(".quiz-option").forEach(option => {
        option.addEventListener("click", function () {
            const input = option.previousElementSibling;
            const newValue = input.value;

            // Antwort speichern
            answers[current_question.name] = newValue;
            input.checked = true;

            // Antworten einfärben
            highlightSelectedAnswer(current_question.name);

            window.dataLayer.push({
              event: 'bikeberater',
              bikeberaterAction: 'answer',
              bikeberaterStep: currentQuestionIndex + 1,
              bikeberaterAnsweredQuestion: current_question.name,
              bikeberaterAnswer: newValue,
              bikeberaterTargetAudience: answers.target_audience || null,
              bikeberaterBikeType: answers.bike_type || null,
              bikeberaterDrivingStyle: answers.driving_style_muskelkraft || answers.driving_style_ebike || null,
              bikeberaterStyleChoice: answers.driving_style_option1 || answers.driving_style_option2 || answers.driving_style_option3 || null,
              bikeberaterBudget: (
                answers[`bike_budget_${selectedBikeCategory}`] ||
                answers[`ebike_budget_${selectedBikeCategory}`] ||
                null
              ),
              bikeberaterCategory: selectedBikeCategory || null,
              
            });

            // Fragenflow updaten
            updateQuestionFlow();

            // Fortschritt aktualisieren
            forceProgressTo100IfFinal();

            // Falls nicht letzte Frage, zur nächsten gehen
            if (currentQuestionIndex < questionFlow.length - 1) {
                currentQuestionIndex++;
                displayQuestion();
            }

            toggleNextButton();
            updateButtonStates();
        });
    });

    // Direkt nach dem Rendern → Eingefärbte Antwort anzeigen
    const selectedInput = document.querySelector(`input[name="${current_question.name}"]:checked`);
    if (selectedInput) {
        const selectedLabel = selectedInput.nextElementSibling;
        if (selectedLabel) {
            selectedLabel.classList.add("selected");
        }
    }

    toggleNextButton();
    forceProgressTo100IfFinal();
}


function highlightSelectedAnswer(currentName) {
  document.querySelectorAll(`input[name="${currentName}"]`).forEach(input => {
    input.nextElementSibling.classList.toggle("selected", input.checked);
  });
}

//Funktion, um den "Nächste"-Button basierend auf der Auswahl zu aktivieren/deaktivieren
function toggleNextButton() {
  let lastRelevantIndex = questionFlow.length - 1;
  let isFirstQuestion = currentQuestionIndex === 0;
  let selected_answer = answers[questionFlow[currentQuestionIndex]];

  // --- Wichtig: direkt am Anfang prüfen ---
  if (isFirstQuestion && !selected_answer) {
    next_btn.classList.add("hidden-bb");
    next_btn.disabled = true;
    finish_btn.classList.add("hidden-bb");
    return;
  }

  // Prüfen, ob die aktuelle Frage eine Budgetfrage ist
  let isBudgetQuestion = questionFlow[currentQuestionIndex]?.startsWith("bike_budget_") || questionFlow[currentQuestionIndex]?.startsWith("ebike_budget_");

  // Prüfen, ob die aktuelle Frage die letzte Frage im Flow ist
  let isLastQuestion = currentQuestionIndex === lastRelevantIndex;

  // Falls der Kinderflow aktiv ist, keine Budgetfragen beachten, sondern prüfen, ob das Alter bereits gefragt wurde
  if (answers.target_audience === "Kinder") {
    isLastQuestion = questionFlow[currentQuestionIndex] === "kids_age_bike" || questionFlow[currentQuestionIndex] === "kids_age_ebike";
  }

  // --- Button-Zustände ---
  next_btn.classList.toggle("hidden-bb", isLastQuestion);
  next_btn.disabled = !selected_answer;

  prev_btn.classList.toggle("hidden-bb", isFirstQuestion);

  finish_btn.classList.toggle("hidden-bb", !isLastQuestion);
  finish_btn.disabled = !selected_answer;

  if (isLastQuestion && selected_answer) {
    finish_btn.classList.add("enabled");
  } else {
    finish_btn.classList.remove("enabled");
  }
}


//Funktion zur Aktualisierung der Buttons (Zurück/Nächste/Fertig)
function updateButtonStates() {
    let totalQuestions = questionFlow.length;
    let isFirstQuestion = currentQuestionIndex === 0;
    let selected_answer = answers[questionFlow[currentQuestionIndex]];

    let lastRelevantIndex = totalQuestions - 1;
    while (lastRelevantIndex > 0 && (questionFlow[lastRelevantIndex].startsWith("bike_budget_") || questionFlow[lastRelevantIndex].startsWith("ebike_budget_"))) {
        lastRelevantIndex--;
    }

    let isBudgetQuestion = questionFlow[currentQuestionIndex]?.startsWith("bike_budget_") || questionFlow[currentQuestionIndex]?.startsWith("ebike_budget_");
    let isFinalBudgetQuestion = isBudgetQuestion && currentQuestionIndex === totalQuestions - 1;

    // Letzte normale Frage bestimmen
    let isLastNonBudgetQuestion = currentQuestionIndex === lastRelevantIndex && !isBudgetQuestion;
    
    // Spezielle Bedingung für den Kinderflow: Letzte Frage ist das Alter
    let isLastQuestion = isFinalBudgetQuestion || (isBudgetQuestion && currentQuestionIndex === totalQuestions - 1);
    if (answers.target_audience === "Kinder") {
        isLastQuestion = questionFlow[currentQuestionIndex] === "kids_age_bike" || questionFlow[currentQuestionIndex] === "kids_age_ebike";
    }

    // Buttons richtig setzen
    prev_btn.classList.toggle("hidden-bb", isFirstQuestion);

    // "Nächste"-Button nur anzeigen, wenn **nicht** die letzte Frage
    next_btn.classList.toggle("hidden-bb", isLastQuestion);
    next_btn.disabled = !selected_answer;

    // "Fertig"-Button nur in der **allerletzten** Frage sichtbar
    finish_btn.classList.toggle("hidden-bb", !isLastQuestion);
    finish_btn.disabled = !selected_answer;

    // Falls der "Fertig"-Button aktiv ist, CSS-Klasse setzen
    if (isLastQuestion && selected_answer) {
        finish_btn.classList.add("enabled");
    } else {
        finish_btn.classList.remove("enabled");
    }
}

//Layer 1: Event-Listener für den "Fertig" Button | Event: Hauptübersicht anzeigen
finish_btn.addEventListener("click", function () {
  window.dataLayer.push({
    event: 'bikeberater',
    bikeberaterAction: 'finished',
    bikeberaterTotalQuestions: questionFlow.length,
    bikeberaterAnsweredQuestions: Object.keys(answers).length,
    bikeberaterTargetAudience: answers.target_audience || null,
    bikeberaterBikeType: answers.bike_type || null,
    bikeberaterDrivingStyle: answers.driving_style_muskelkraft || answers.driving_style_ebike || null,
    bikeberaterStyleChoice: answers.driving_style_option1 || answers.driving_style_option2 || answers.driving_style_option3 || null,
    bikeberaterBudget: (
      answers[`bike_budget_${selectedBikeCategory}`] ||
      answers[`ebike_budget_${selectedBikeCategory}`] ||
      null
    ),
    bikeberaterCategory: selectedBikeCategory || null,
    
  });

  updateResultList();
  showDrawerSection("resultSection");
  updateFooterSection("footer-resultStep1");
});

// "Schließen" aus Ergebnisübersicht
closeModal?.addEventListener("click", () => {
  hideDrawerSections();
  showDrawerSection("quizSection");
});

closeButton?.addEventListener("click", () => {
  hideDrawerSections();
  showDrawerSection("quizSection");
  updateFooterSection("nav-buttons");
});

//Layer 2: Bearbeitungsmodul\\

//Formatieren des Budget Values [min:X / min:X,max:X / max:X]
function formatBudgetValue(value) {
    if (!value) return "";

    if (value.includes("min:") && value.includes("max:")) {
        let [min, max] = value.match(/\d+/g);
        return `${min}€ - ${max}€`;
    } else if (value.includes("min:")) {
        let min = value.match(/\d+/)[0];
        return `Ab ${min}€`;
    } else if (value.includes("max:")) {
        let max = value.match(/\d+/)[0];
        return `Bis ${max}€`;
    }
    
    return value;
}

function updateResultList() {
  const iconHTML = document.getElementById("icon-template").innerHTML;

  resultList.innerHTML = questionFlow
    .map((key, index) => {
      const question = questions.find(q => q.name === key);
      if (!question || !answers[key]) return "";

      const userAnswer = answers[key];

      // Passende Option zur Antwort finden
      const selectedOption = question.options.find(opt => opt.value === userAnswer);

      // Antwort ggf. formatieren
      const formattedAnswer = key.includes("budget") ? formatBudgetValue(userAnswer) : userAnswer;

      const isEditable = index > 3;
      const editButtonHTML = isEditable
        ? `<span class="edit-button icon-with-text edit-text" data-question="${key}">${iconHTML}bearbeiten</span>`
        : "";

      return `
        <li class="result-card">
          <h4 class="option-heading">${question.text}</h4>
          <p class="advisor_description">${formattedAnswer} ${editButtonHTML}</p>
        </li>`;
    })
    .join("");
}

//Funktion zur Anzeige des Bearbeitungs-Moduls
resultList.addEventListener("click", (event) => {
  let target = event.target;

  if (target.classList.contains("edit-text")) {
    target = target.closest(".edit-button");
  }

  if (target && target.classList.contains("edit-button")) {
    currentEditKey = target.dataset.question;

    //Prüfen, ob die aktuelle Frage die vierte Frage ist (nicht editierbar)
    const questionIndex = questionFlow.indexOf(currentEditKey);
    if (questionIndex <= 3) return;

    const question = questions.find((q) => q.name === currentEditKey);

    //Frage und Antwort ins Bearbeitungs-Pop-Up einfügen
    editQuestionText.textContent = question.text;

    let filteredOptions = [...question.options];

    // Falls die Frage "driving_style_option3" ist und Muskelkraft gewählt wurde, die E-Bike Option ausblenden
    if (
      currentEditKey === "driving_style_option3" &&
      answers.bike_type === "Muskelkraft"
    ) {
      filteredOptions = filteredOptions.filter(
        (option) =>
          option.value !==
          "Ich will ein leichtes, sportliches E-Bike für Trails & Touren"
      );
    }

    // HTML generieren
    editOptionsContainer.innerHTML = filteredOptions
      .map((option) => {
        const isSelected = answers[currentEditKey] === option.value;
        return `
          <input 
            type="radio" 
            id="edit_${option.value}" 
            name="editOption" 
            value="${option.value}" 
            ${isSelected ? "checked" : ""}
          />
          <label for="edit_${option.value}" class="quiz-option${isSelected ? " selected" : ""}">
            <div class="img-wrap">
              <img src="${option.img}" alt="${option.label}" />
            </div>
            <div class="option-inner heading-text-inner">
              <h3 class="option-heading">${option.label}</h3>
              ${option.description ? `<p class="advisor_description">${option.description}</p>` : ""}
            </div>
          </label>`;
      })
      .join("");


    // EventListener für Klicks auf Labels
    document
      .querySelectorAll("#editOptionsContainer label")
      .forEach((label) => {
        label.addEventListener("click", () => {
          const input = label.previousElementSibling;
          input.checked = true;

          // Alle entfernen
          document
            .querySelectorAll("#editOptionsContainer label")
            .forEach((l) => l.classList.remove("selected"));

          // Aktuelle hinzufügen
          label.classList.add("selected");

          // Button aktivieren/deaktivieren
          if (input.value !== answers[currentEditKey]) {
            saveEditButton.disabled = false;
            saveEditButton.classList.add("enabled");
          } else {
            saveEditButton.disabled = true;
            saveEditButton.classList.remove("enabled");
          }
        });
      });

    // Initialzustand: Button deaktiviert
    saveEditButton.disabled = true;
    saveEditButton.classList.remove("enabled");

    // Ansicht und Footer anzeigen
    showDrawerSection("editSection");
    updateFooterSection("footer-edit");
  }
});

  
//Event: Bearbeiten-Pop-Up: Änderungen speichern
saveEditButton.addEventListener("click", () => {
  const selectedOption = document.querySelector('input[name="editOption"]:checked');
  if (selectedOption) {
    answers[currentEditKey] = selectedOption.value;

    window.dataLayer.push({
      event: 'bikeberater',
      bikeberaterAction: 'edit_answer',
      bikeberaterStep: questionFlow.indexOf(currentEditKey) + 1,
      bikeberaterAnsweredQuestion: currentEditKey,
      bikeberaterNewAnswer: answers[currentEditKey],
      bikeberaterTargetAudience: answers.target_audience || null,
      bikeberaterBikeType: answers.bike_type || null,
      bikeberaterDrivingStyle: answers.driving_style_muskelkraft || answers.driving_style_ebike || null,
      bikeberaterStyleChoice: answers.driving_style_option1 || answers.driving_style_option2 || answers.driving_style_option3 || null,
      bikeberaterBudget: (
        answers[`bike_budget_${selectedBikeCategory}`] ||
        answers[`ebike_budget_${selectedBikeCategory}`] ||
        null
      ),
      bikeberaterCategory: selectedBikeCategory || null,
      
    });

    updateResultList();
    showDrawerSection("resultSection");
    updateFooterSection("footer-resultStep1");
  }
});

closeEditButtons.forEach(button => {
  button.addEventListener("click", (event) => {
    event.stopPropagation();

    const selectedOption = document.querySelector('input[name="editOption"]:checked');
    const currentValue = selectedOption?.value;
    const originalValue = answers[currentEditKey];

    // Nur anzeigen, wenn sich die Auswahl geändert hat
    if (currentValue && currentValue !== originalValue) {
      showDrawerSection("closeConfirmSection");
      updateFooterSection("footer-closeConfirm");
    } else {
      // Keine Änderung → direkt schließen
      showDrawerSection("resultSection");
      updateFooterSection("footer-resultStep1");
    }
  });
});


//Sicherstellen, dass das Bestätigungspopup nur über Buttons geschlossen wird
confirmCloseButton.addEventListener("click", () => {
  showDrawerSection("resultSection");
  updateFooterSection("footer-resultStep1");
});

cancelCloseButton.addEventListener("click", () => {
  showDrawerSection("editSection");
  updateFooterSection("footer-edit");
});

//Verhindern, dass ein Klick außerhalb das Bestätigungspopup schließt
confirmCloseModal.addEventListener("click", (event) => {
  if (event.target === confirmCloseModal) {
    event.stopPropagation();
  }
});

//Event-Listener für "Quiz Neustarten"-Button (öffnet das Pop-Up)
restartQuizButton.addEventListener("click", function () {
    window.dataLayer.push({
    event: 'bikeberater',
    bikeberaterAction: 'click_restart',
    bikeberaterTotalQuestions: questionFlow.length,
    bikeberaterAnsweredQuestions: Object.keys(answers).length,
    bikeberaterTargetAudience: answers.target_audience || null,
    bikeberaterBikeType: answers.bike_type || null,
    bikeberaterDrivingStyle: answers.driving_style_muskelkraft || answers.driving_style_ebike || null,
    bikeberaterStyleChoice: answers.driving_style_option1 || answers.driving_style_option2 || answers.driving_style_option3 || null,
    bikeberaterBudget: (
      answers[`bike_budget_${selectedBikeCategory}`] ||
      answers[`ebike_budget_${selectedBikeCategory}`] ||
      null
    ),
    bikeberaterCategory: selectedBikeCategory || null,
    
  });
  showDrawerSection("restartConfirmSection");
  updateFooterSection("footer-restartConfirm");
});

//Event-Listener für "Nein, abbrechen" → Schließt das Pop-Up
cancelRestartButton.addEventListener("click", function () {
    window.dataLayer.push({
    event: 'bikeberater',
    bikeberaterAction: 'cancel_restart',
    bikeberaterTotalQuestions: questionFlow.length,
    bikeberaterAnsweredQuestions: Object.keys(answers).length,
    bikeberaterTargetAudience: answers.target_audience || null,
    bikeberaterBikeType: answers.bike_type || null,
    bikeberaterDrivingStyle: answers.driving_style_muskelkraft || answers.driving_style_ebike || null,
    bikeberaterStyleChoice: answers.driving_style_option1 || answers.driving_style_option2 || answers.driving_style_option3 || null,
    bikeberaterBudget: (
      answers[`bike_budget_${selectedBikeCategory}`] ||
      answers[`ebike_budget_${selectedBikeCategory}`] ||
      null
    ),
    bikeberaterCategory: selectedBikeCategory || null,
    
  });
  showDrawerSection("resultSection");
  updateFooterSection("footer-resultStep1");
});

//Event-Listener für "Ja, neustarten" → Setzt das Quiz zurück und startet es neu
confirmRestartButton.addEventListener("click", function () {
    window.dataLayer.push({
    event: 'bikeberater',
    bikeberaterAction: 'confirm_restart',
    bikeberaterTotalQuestions: questionFlow.length,
    bikeberaterAnsweredQuestions: Object.keys(answers).length,
    bikeberaterTargetAudience: answers.target_audience || null,
    bikeberaterBikeType: answers.bike_type || null,
    bikeberaterDrivingStyle: answers.driving_style_muskelkraft || answers.driving_style_ebike || null,
    bikeberaterStyleChoice: answers.driving_style_option1 || answers.driving_style_option2 || answers.driving_style_option3 || null,
    bikeberaterBudget: (
      answers[`bike_budget_${selectedBikeCategory}`] ||
      answers[`ebike_budget_${selectedBikeCategory}`] ||
      null
    ),
    bikeberaterCategory: selectedBikeCategory || null,
    
  });

  Object.keys(answers).forEach(key => delete answers[key]);
  currentQuestionIndex = 0;
  updateQuestionFlow();
  displayQuestion();
  updateButtonStates();
  showDrawerSection("quizSection");
  updateFooterSection("nav-buttons");
});


//Event: "Weiter"-Button -> Zeigt den zweiten Schritt an
nextButton.addEventListener("click", function () {
  window.dataLayer.push({
    event: 'bikeberater',
    bikeberaterAction: 'next_result_step',
    bikeberaterFromStep: 1,
    bikeberaterToStep: 2
  });

  resultStep1.classList.add("hidden-bb");
  resultStep2.classList.remove("hidden-bb");
  updateFooterSection("footer-resultStep2");
});

//Event: "Zurück"-Button -> Zurück zum ersten Schritt
backToStep1.addEventListener("click", function () {
  window.dataLayer.push({
    event: 'bikeberater',
    bikeberaterAction: 'back_result_step',
    bikeberaterFromStep: 'Support or Browse',
    bikeberaterToStep: 'Bikeprofile overview'
  });

  resultStep2.classList.add("hidden-bb");
  resultStep1.classList.remove("hidden-bb");
  updateFooterSection("footer-resultStep1");
});

//Event-Listener für den "Zurück"-Button im Kontaktformular
backToStep2.addEventListener("click", function (e) {
  e.preventDefault();

  window.dataLayer.push({
    event: 'bikeberater',
    bikeberaterAction: 'back_to_result',
    bikeberaterFromStep: 'Contactform',
    bikeberaterToStep: 'Support or Browse'
  });
  
  showDrawerSection("resultSection");
  resultStep1.classList.add("hidden-bb");
  resultStep2.classList.remove("hidden-bb");
  updateFooterSection("footer-resultStep2");
});



// Direkt weiterleiten, sobald eine Option ausgewählt wird
document.querySelectorAll("input[name='nextStep']").forEach(input => {
  input.addEventListener("click", function () {
    if (this.id === "consultation") {
      resultStep2.classList.add("hidden-bb");
      showDrawerSection("consultationSection");
      updateFooterSection("footer-contact");
    } else if (this.id === "browseBikes") {
      window.dataLayer.push({
        event: 'bikeberater',
        bikeberaterAction: 'browse_bikes',
        bikeberaterTargetAudience: answers.target_audience || null,
        bikeberaterBikeType: answers.bike_type || null,
        bikeberaterDrivingStyle: answers.driving_style_muskelkraft || answers.driving_style_ebike || null,
        bikeberaterStyleChoice: answers.driving_style_option1 || answers.driving_style_option2 || answers.driving_style_option3 || null,
        bikeberaterBudget: (
          answers[`bike_budget_${selectedBikeCategory}`] ||
          answers[`ebike_budget_${selectedBikeCategory}`] ||
          null
        ),
        bikeberaterCategory: selectedBikeCategory || null,
        bikeberaterTotalQuestions: questionFlow.length,
        bikeberaterAnsweredQuestions: Object.keys(answers).length
      });

      const collectionUrl = generateCollectionUrl();
      window.open(collectionUrl, "_blank");
    }
  });
});


function generateCollectionUrl() {
    let baseUrl = "https://zigarrendepotdepot.com/collections/";
    let filters = ["filter.v.availability=1"]; 
    let mapBikeCategory = selectedBikeCategory || "sale";

    // ---------------- Budget ermitteln ---------------- //
    let budgetKey = answers.bike_type === "Muskelkraft" 
        ? `bike_budget_${mapBikeCategory}` 
        : `ebike_budget_${mapBikeCategory}`;

    let budgetValue = answers[budgetKey];

    // Falls ein Budget definiert ist, parsen und als Preisfilter anhängen
    if (budgetValue) {
        let priceFilter = "";

        if (budgetValue.includes("min:") && budgetValue.includes("max:")) {
            let [min, max] = budgetValue.match(/\d+/g);
            priceFilter = `filter.v.price.gte=${min}&filter.v.price.lte=${max}`;
        } else if (budgetValue.includes("min:")) {
            let min = budgetValue.match(/\d+/)[0];
            priceFilter = `filter.v.price.gte=${min}`;
        } else if (budgetValue.includes("max:")) {
            let max = budgetValue.match(/\d+/)[0];
            priceFilter = `filter.v.price.lte=${max}`;
        }

        if (priceFilter) {
            filters.push(priceFilter);
        }
    }    

    // ------------- Kinder-Flow () ------------- //
    if (answers.target_audience === "Kinder") {
        if (answers.bike_type === "Muskelkraft") {
            switch (answers.kids_age_bike) {
                case "2,5 - 3 Jahre":
                    mapBikeCategory = "bikes-12-zoll";
                    break;
                case "3 Jahre":
                    mapBikeCategory = "bikes-14-zoll";
                    break;
                case "3 - 4 Jahre":
                    mapBikeCategory = "bikes-16-zoll";
                    break;
                case "4 - 5 Jahre":
                    mapBikeCategory = "bikes-18-zoll";
                    break;
                case "5 - 6 Jahre":
                    mapBikeCategory = "bikes-20-zoll";
                    break;
                case "7 - 8 Jahre":
                    mapBikeCategory = "kinderbikes-24-zoll";
                    break;
                case "9 - 11 Jahre":
                    mapBikeCategory = "bikes-26-zoll";
                    break;
                default:
                    mapBikeCategory = "kids-fahrraeder";
            }
        } else if (answers.bike_type === "E-Bike") {
            switch (answers.kids_age_ebike) {
                case "6 - 7 Jahre":
                    mapBikeCategory = "e-bike-20-zoll";
                    break;
                case "8 - 9 Jahre":
                    mapBikeCategory = "e-bike-24-zoll";
                    break;
                case "10 Jahre oder älter":
                    mapBikeCategory = "e-bike-26-zoll";
                    break;
                default:
                    mapBikeCategory = "kids-e-bike";
            }
        }
    } 
    // ------------- Mapping für Muskelkraft ------------- //
    else if (answers.bike_type === "Muskelkraft") {
        const muscleBikeMapping = {
            "rennrad": "rennrad",
            "city_urban": "city-urban",
            "trekking": "trekking",
            "gravel": "gravelbike",
            "hardtail": "hardtail",
            "fully": "fully",
            "sale": "sale"
        };
        mapBikeCategory = muscleBikeMapping[mapBikeCategory] || "fahrrad";
    } 
    // ------------- Mapping für E-Bike ------------- //
    else if (answers.bike_type === "E-Bike") {
        const eBikeMapping = {
            "rennrad": "e-rennrad",
            "city_urban": "e-city-urban",
            "trekking": "e-trekking",
            "gravel": "e-gravel",
            "hardtail": "e-hardtail",
            "fully": "e-fully",
            "light_mtb": "light-e-mtb",
            "sale": "sale"
        };
        mapBikeCategory = eBikeMapping[mapBikeCategory] || "e-bike";
    }

    // ------------- URL generieren ------------- //
    baseUrl += mapBikeCategory;

    // URL mit Filtern zusammenbauen
    if (filters.length > 0) {
        baseUrl += "?" + filters.join("&");
    }

    return baseUrl;
}

// Sobald der Drawer geöffnet wird, rufen wir showDrawerSection("quizSection") auf
const bikeAdvisorDrawer = document.getElementById("BikeAdvisorDrawer");

if (bikeAdvisorDrawer) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === "open") {
        if (bikeAdvisorDrawer.hasAttribute("open")) {
          // Drawer wurde geöffnet
          showDrawerSection("quizSection");
            window.dataLayer.push({
            event: 'bikeberater',
            bikeberaterAction: 'open_drawer',
            bikeberaterStep: 1,
          });  
          updateFooterSection("nav-buttons");
          disableBodyScroll(); // verhindert Scrollen im Hintergrund
        } else {
          // Drawer wurde geschlossen
          enableBodyScroll(); // erlaubt wieder das Scrollen
          hideDrawerSections(); // optional: alle Drawer-Abschnitte ausblenden
        }
      }
    });
  });

  observer.observe(bikeAdvisorDrawer, {
    attributes: true,
    attributeFilter: ["open"]
  });
}




// Initialisierung
updateQuestionFlow();
displayQuestion();
updateButtonStates();
toggleNextButton();


//Abschicken des Formulars
function handleConsultationFormSubmit(e) {
    var form = document.getElementById('consultation-form');
    const formData = new FormData(form);

    const requiredFields = Array.from(form.querySelectorAll('[required]')).map(input => input.name);
    let missingFields = [];

    formData.forEach((value, key) => {
        if (requiredFields.includes(key) && !value.trim()) {
            missingFields.push(key.replace(/_/g, ' '));
        }
    });

    if (missingFields.length > 0) {
        document.querySelector('[data-error-message]').hidden = false;
        return;
    }

    let bodyString = '';
    const excludedKeys = [''];

    //Füge vorhandene Formulardaten hinzu
    formData.forEach((value, key) => {
        if (value) {
            let formattedKey = key.replace(/_/g, ' ');
            let formattedValue = value.replace(/_/g, ' ').replace(/\n/g, '\n');
            if (formattedKey != "variant select") {
                bodyString += key.includes('head_') 
                ? `<h2>${formattedValue}</h2>` 
                : excludedKeys.includes(formattedKey) 
                    ? `<b>${formattedValue}</b><br>`
                    : `<b>${formattedKey}:</b> ${formattedValue}<br>`;
            }
        }
    });

    //Füge die Bikeberater-Antworten hinzu
    if (Object.keys(answers).length > 0) {
        bodyString += `<h2>Bikeberater Auswahl:</h2>`;
        Object.keys(answers).forEach(key => {
            let question = questions.find(q => q.name === key);
            if (question) {
                let formattedAnswer = key.includes("budget") ? formatBudgetValue(answers[key]) : answers[key];
                bodyString += `<b>${question.text}</b><br>${formattedAnswer}<br>`;
            }
        });
    }

    const emailData = {
        to_email: "verkauf@liquid-life.de",
        subject: "Liquid Life: Bikeberater-Anfrage",
        from_email: "smtprelay@liquid-life.de",
        from_name: `${formData.get('Vorname')} ${formData.get('Nachname')}`,
        reply_to_email: formData.get('Email'),
        body: bodyString
    };

    fetch('https://heroku.liquid-life.com/sendmail', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(emailData)
    })
    .then(response => { 
        const successDiv = document.querySelector('[data-success-message]');
        const errorDiv = document.querySelector('[data-error-message]');
        const submitButton = document.querySelector('button[name="submitConsultationForm"]');
        if (response.status == 200) {
            document.querySelector('.banner--success').hidden = false;
            successDiv.hidden = false;
            errorDiv.hidden = true;

            window.dataLayer.push({
              event: 'bikeberater',
              bikeberaterAction: 'form_submitted',
              bikeberaterTargetAudience: answers.target_audience || null,
              bikeberaterBikeType: answers.bike_type || null,
              bikeberaterDrivingStyle: answers.driving_style_muskelkraft || answers.driving_style_ebike || null,
              bikeberaterStyleChoice: answers.driving_style_option1 || answers.driving_style_option2 || answers.driving_style_option3 || null,
              bikeberaterBudget: (
                answers[`bike_budget_${selectedBikeCategory}`] ||
                answers[`ebike_budget_${selectedBikeCategory}`] ||
                null
              ),
              bikeberaterCategory: selectedBikeCategory || null,
              bikeberaterTotalQuestions: questionFlow.length,
              bikeberaterAnsweredQuestions: Object.keys(answers).length
            });
          
        } else {
            errorDiv.hidden = false;
        }
        if (submitButton) {
            submitButton.hidden = true;
        }
    })
    .catch(error => { 
        const errorDiv = document.querySelector('[data-error-message]');
        const submitButton = document.querySelector('button[name="submitConsultationForm"]');
        errorDiv.hidden = false;

        window.dataLayer.push({
          event: 'bikeberater',
          bikeberaterAction: 'form_error'
        });

        if (submitButton) {
            submitButton.hidden = true;
        }
    });
}